module.exports = {
    development : false,
    cloudflare: {
        enabled: true,
        token: '16082753d595462c9d749babc0446ea6'
    },
    wrapper: {
      url: "https://eosapi.eoxvantage.com/"
    },
    ui: {
      url: "https://taruvi.eoxvantage.com/"
    },
    api: {
      url: "https://eosapi.eoxvantage.com/"
    },
    desktop: {
        settings: {
            font: "Roboto",
            theme: "Vision",
            panels: [
            {
              position: "top",
              items: [
                { name: "myHome", index: 1 },
                { name: "globalSearch", index: 3 },
                { name: "notificationCenter", index: 4 },
              ],
            }
          ],
        }
    },
    storage: {
        type: "sharepoint"
    },
    okta: {
        oktaDomain: "",
        oktaClientId: "",
        oktaRedirectUri: ""
    },
    authType : "keycloak",
    keycloak: {
        keycloakRedirectUrl:"https://taruvi.eoxvantage.com/",
        keycloakUrl: "https://secure.eoxvantage.com/",
        keycloakRealm: "eos.eoxvantage.com",
        keycloakClientId: "eos.eoxvantage.com-cli",
    },
}
